import { hasWLAccess } from 'api/brand/utils';
import { Outlet, RouteObject } from 'react-router-dom';
import WhiteLabelHomepage from './homepage';
import { ProtectedDefaultLayout } from 'layouts/DefaultLayout/ProtectedDefaultLayout';
import { PermissionProtectedRoute } from 'components/Permission/PermissionProtectedRoute';
import { TokenUserPermissions } from 'api/users/schemas/Users';
import Header from './Header';
import { useEffect, useState } from 'react';
import OktaAuth from '@okta/okta-auth-js';

export const WhiteLabel = () => {
  return (
    <div className="relative max-w-full bg-background-base-surface-1">
      <Header />
      <Outlet />
    </div>
  );
};

export const useWhiteLabelRoutes = (oktaAuth: OktaAuth) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await oktaAuth.isAuthenticated();
      setIsAuthenticated(result);
    };
    checkAuth();
    const handler = () => checkAuth();
    oktaAuth.authStateManager.subscribe(handler);
    return () => {
      oktaAuth.authStateManager.unsubscribe(handler);
    };
  }, [oktaAuth]);

  if (isAuthenticated === null || !hasWLAccess) return [];

  if (!isAuthenticated && hasWLAccess)
    return [
      {
        element: <WhiteLabel />,
        children: [{ path: '/', element: <WhiteLabelHomepage /> }],
      },
    ];
  return [];
};

export const whiteLabelForAdmin: RouteObject[] = [
  {
    path: '/white-label',
    element: (
      <ProtectedDefaultLayout>
        <PermissionProtectedRoute
          forGraniteUser
          permission={[
            TokenUserPermissions.WHITELABEL_MANAGE,
            TokenUserPermissions.WHITELABEL_READ,
            TokenUserPermissions.WHITELABEL_WRITE,
          ]}
        />
      </ProtectedDefaultLayout>
    ),
    children: [
      {
        element: <WhiteLabel />,
        children: [{ index: true, element: <WhiteLabelHomepage /> }],
      },
    ],
  },
];
